import { render, staticRenderFns } from "./chateau-haut-batailley.vue?vue&type=template&id=3354f876&scoped=true"
import script from "./chateau-haut-batailley.vue?vue&type=script&lang=js"
export * from "./chateau-haut-batailley.vue?vue&type=script&lang=js"
import style0 from "./chateau-haut-batailley.vue?vue&type=style&index=0&id=3354f876&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3354f876",
  null
  
)

export default component.exports